import { render, staticRenderFns } from "./SocialCard.vue?vue&type=template&id=040d2677&scoped=true&"
import script from "./SocialCard.vue?vue&type=script&lang=js&"
export * from "./SocialCard.vue?vue&type=script&lang=js&"
import style0 from "./SocialCard.scss?vue&type=style&index=0&id=040d2677&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d2677",
  null
  
)

export default component.exports